// extracted by mini-css-extract-plugin
export var active = "_i1-2";
export var recordingDot = "_i1-1";
export var recordingIndicator = "_i1-0";